import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BadgeType } from '../types/badge.type';

@Component({
  selector: 'app-badge-row',
  templateUrl: './badge-row.component.html',
  styleUrls: ['./badge-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeRowComponent {
  @Input()
  items: BadgeType[] = [];

  @Input()
  max: number = 3;

  @Input()
  units: string | null = null;

  @Input()
  onlyCounter: boolean = false;

  @Output()
  closeClicked: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  moreClicked: EventEmitter<void> = new EventEmitter();

  trackByTitle(_: number, item: BadgeType): string {
    return item.text;
  }
}
